import { Component, OnInit, inject } from '@angular/core';
import {CommonModule} from '@angular/common';
import {ActivatedRoute} from "@angular/router";
import {DataService} from "../services/data.service";
import {FileSizePipe} from "../pipes/file-size.pipe";
import {FormsModule} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {environment} from "../../environments/environment";

@Component({
    selector: 'app-show',
    imports: [CommonModule, FileSizePipe, FormsModule],
    templateUrl: './show.component.html',
    styleUrl: './show.component.scss'
})
export class ShowComponent implements OnInit {

    private route = inject(ActivatedRoute);
    private dataService = inject(DataService);
    private toastrService = inject(ToastrService);

    readonly environment = environment;

    code!: string | null;
    hash: string | null = null;

    element: any;
    password!: string;
    error!: string;

    showFiles = false;
    parent: string|null = null;

    downloading = false;

    ngOnInit(): void {
        this.code = this.route.snapshot.paramMap.get('code');

        this.getElement();
    }

    getElement() {
        this.dataService.request('Show/getData', {
            code: this.code,
            hash: this.hash
        }).subscribe((response: any) => {
            if (response.error) {
                this.error = response.error;
            } else {
                this.element = response.data;

                if (this.element.type == 'folder' && !this.element.password) {
                    this.showFiles = true;
                }
            }
        });
    }

    selectElement(hash: string) {
        this.parent = this.code;
        this.hash = hash;
        this.password = '';

        this.getElement();
    }

    selectParent() {
        this.code = this.parent;
        this.hash = null;

        this.getElement();
    }

    checkPassword() {
        this.dataService.request('Show/checkPassword', {
            code: this.code,
            hash: this.hash,
            password: this.password,
        }).subscribe((response: any) => {
            if (response.error) {
                this.toastrService.error(response.error, "Fehler");
            } else {
                this.toastrService.success('Passwort korrekt', "Erfolg");

                this.showFiles = true;
            }
        });
    }

    download() {
        this.downloading = true;

        this.dataService.request('Show/download', {
            code: this.code,
            hash: this.hash,
            password: this.password,
        }).subscribe((response: any) => {
            this.downloading = false;

            if (response.error) {
                this.toastrService.error(response.error, "Fehler");
            } else {
                this.toastrService.success('Download wird gestartet', "Erfolg");

                this.downloadBase64File(response.data.data, response.data.mime, response.data.name);
            }
        });
    }

    openLink() {
        this.dataService.request('Show/getLink', {
            code: this.code,
            hash: this.hash,
            password: this.password,
        }).subscribe((response: any) => {
            if (response.error) {
                this.toastrService.error(response.error, "Fehler");
            } else {
                // open link in new tab
                window.open(response.url, '_blank');
            }
        });
    }

    downloadBase64File(base64: string, mimeType: string, fileName: string) {
        // Base64-Präfix entfernen, falls vorhanden
        let byteCharacters = atob(base64.split(',')[1] || base64);

        // Base64 in Binärdaten umwandeln
        let byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);

        // Blob erstellen
        let blob = new Blob([byteArray], { type: mimeType });

        // Blob-URL erzeugen
        let blobUrl = URL.createObjectURL(blob);

        // <a>-Tag erzeugen
        let a = document.createElement('a');
        a.href = blobUrl;
        a.download = fileName || 'download';
        document.body.appendChild(a);
        a.click();

        // Cleanup
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
    }
}
